import React, {useContext, useEffect, useRef, useState} from "react";
// jquery
import $ from "jquery";
// React Bootstrap
import {Button, Col, Form, FormControl, InputGroup, Navbar} from "react-bootstrap";
// Componentes
import TablaCargos from "./TablaCargos";
import FormCargo from "./FormCargo";
import TooltipIcon from "../generic/TooltipIcon";
// Custom spinner
import CustomSpinner from "../generic/CustomSpinner";
// Contexto
import {ModalContext} from "../../context/modalContext";
import {AlertBoxContext} from "../../context/alertBoxContext";
import {cargosContext} from "../../contexto";
// Styled Components
import styled from "styled-components";
// Utils
import {addYears, dateToString2} from "../../utils";
// Hooks
import {useIsMount} from "../hooks/UseIsMount";
import useObserver from "../hooks/UseObserver";

const CustomNavBar = styled(Navbar)`
  min-width: 200px;
  padding: 0px;
  margin: 0px;
  padding-top: 10px;
`;

const CustomTable = styled.div`
  position: relative;
  overflow: auto;
  max-height: 500px;
`;

const Cargos = ({ type, idEntidad, idSubEntidad = "" }) => {
  // Spinner
  const [loading, setLoading] = useState(false);

  // Contexto
  const { modalSetShow, modalSetTitle, modalSetContent } = useContext(ModalContext);

  // Alertas
  const { addAlert } = useContext(AlertBoxContext);

  // Cargos de la entidad
  const [cargos, setCargos] = useState([]);

  // Filtros, paginación y observador
  const [page, setPage] = useState(1); // Página por la que va
  const [lastPageReached, setLastPageReached] = useState(false); // ultima pagina alcanzada
  const [reload, setReload] = useState(false); // Reload para recargar el observador
  const [isActive, setIsActive] = useState(true);
  const [search, setSearch] = useState("");
  const [startDate, setStartDate] = useState("");
  const [endDate, setEndDate] = useState("");
  const [filtroCargo, setFiltroCargo] = useState("");
  const isMount = useIsMount(); // Se renderiza por primera vez?
  const scrollingDiv = useRef(null); // Div que contendrá el scroll

  // Resetea el explorador con los filtros actuales
  const resetCargos = () => {
    setPage(1);
    setReload(!reload);
  };

  // Para volver a pedir los datos cuando cambia algun filtro
  useEffect(() => {
    if (!isMount) {
      resetCargos();
    }
    scrollingDiv.current.scrollTop = 0;
  }, [isActive, search, startDate, endDate, filtroCargo]);

  useEffect(() => {
    handleGetCargos();
  }, [reload]);

  // **************************************************** GET ************************************************
  // Obtiene los cargos de una entidad
  const getCargos = (url, queryString) => {
    let settings = {
      url: `${url}${queryString}`,
      method: "GET",
      xhrFields: {
        withCredentials: true,
      },
    };
    return $.ajax(settings);
  };

  // Manejador de la respuesta de cargos
  const handleGetCargos = (addToExisting = false) => {
    setPage(page + 1);
    setLoading(true);
//console.log(getUrl())
    getCargos(getUrl(), getQueryString())
      .then((response) => {
        if (response.totalPages <= page) {
          setLastPageReached(true);
        } else {
          setLastPageReached(false);
        }
        if (addToExisting) {
          setCargos([...cargos, ...response.items]);
        } else {
          // Si son activos ordenamos los cargos
          if (isActive) {
            setCargos(response.items.sort(compararCargos));
          } else setCargos(response.items);
        }
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  // **************************************************** POST ************************************************
  // Añade un cargo a la entidad
  const postCargo = (data, noControl) => {
    let settings = {
      url: `${getUrl()}${getQueryStringPostPut()}&noControl=${noControl}`,
      method: "POST",
      xhrFields: {
        withCredentials: true,
      },
      data: data,
    };
    return $.ajax(settings);
  };

  // Manejador para el post de añadir cargo
  const handlePostCargo = (data, noControl) => {
    setLoading(true);
    modalSetShow(false);
    postCargo(data, noControl)
      .then((response) => {
        setLoading(false);
        resetCargos();
        addAlert("Exito", `Se ha añadido el ${cargosContext[type]["cargoServicio"].toLowerCase()} correctamente`, "success");
      })
      .catch(() => {
        setLoading(false);
      });
  };

  // **************************************************** PUT ************************************************
  // Edita un cargo a la entidad
  const putCargo = (data) => {
    let settings = {
      url: `${getUrl()}/${data.id}${getQueryStringPostPut()}`,
      method: "PUT",
      xhrFields: {
        withCredentials: true,
      },
      data: data,
    };
    return $.ajax(settings);
  };

  // Manejador para la edición de la entidad
  const handlePutCargo = (data) => {
    setLoading(true);
    modalSetShow(false);
    putCargo(data)
      .then((response) => {
        resetCargos();
        addAlert("Exito", `Se ha editado el ${cargosContext[type]["cargoServicio"].toLowerCase()} correctamente`, "success");
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };

  // **************************************************** DELETE ************************************************
  // Elimina un cargo a la entidad
  const deleteCargo = (data) => {
    let settings = {
      url: `${getUrl()}/${data.id}`,
      method: "DELETE",
      xhrFields: {
        withCredentials: true,
      },
    };
    return $.ajax(settings);
  };

  // Elimina un cargo en el estado
  const deleteCargoState = (cargoEliminado) => {
    // Posicion del cargo a elimnar en el estado
    let posicion = cargos.indexOf(cargoEliminado);
    // Modificamos el estado con el cargo editado
    let auxCargos = [...cargos];
    auxCargos.splice(posicion, 1);
    setCargos(auxCargos);
  };

  // Manejador para la eliminación de una entidad
  const handleDeleteCargo = (data) => {
    setLoading(true);
    deleteCargo(data)
      .then(() => {
        deleteCargoState(data);
        addAlert("Exito", `Se ha eliminado el ${cargosContext[type]["cargoServicio"].toLowerCase()} correctamente`, "success");
        setLoading(false);
      })
      .catch(() => {
        setLoading(false);
      });
  };
  // **************************************************** UTILS ************************************************
  // Obtiene las distintas url en función del tipo de entidad
  const getUrl = () => {
    switch (type) {
      // Provinciales
      case "gobiernoProvincial":
      case "oficiosProvinciales":
      case "otrosServiciosProvinciales":
      // Dirección general
      case "gobiernoGeneral":
      case "oficiosGenerales":
      case "otrosServiciosGenerales":
        return `${process.env.REACT_APP_API_URL}/provincias/${idEntidad}/serviciosProvinciales`;
      // Representantes legales
      case "rlProvincial":
      case "rlGeneral":
        return `${process.env.REACT_APP_API_URL}/provincias/${idEntidad}/representantesLegales`;
      case "rlObra":
        return `${process.env.REACT_APP_API_URL}/provincias/${idEntidad}/misiones/${idSubEntidad}/representantesLegales`;
      // Comunitarios
      case "serviciosComunitarios":
        return `${process.env.REACT_APP_API_URL}/provincias/${idEntidad}/comunidades/${idSubEntidad}/serviciosComunitarios`;
      // Equipos
      case "equiposComisiones":
        return `${process.env.REACT_APP_API_URL}/provincias/${idEntidad}/gruposTrabajo/${idSubEntidad}/listaMiembros`;
      // Misiones
      case "equiposDirectivosEducativo":
      case "equiposDirectivosAlojamiento":
      case "equiposDirectivosSalud":
      case "equiposDirectivosEspiritualidad":
      case "equiposDirectivosSocial":
        return `${process.env.REACT_APP_API_URL}/provincias/${idEntidad}/misiones/${idSubEntidad}/equipoDirectivo`;
//112022 para poner hermanas que trabajana en la obra

      case "hermanasQueTrabajanObraOProyecto":
        console.log(`${process.env.REACT_APP_API_URL}/provincias/${idEntidad}/misiones/${idSubEntidad}/hermanasQueTrabajanObraOProyecto`)
        return `${process.env.REACT_APP_API_URL}/provincias/${idEntidad}/misiones/${idSubEntidad}/hermanasQueTrabajanObraOProyecto`;
      default:
        return "";
    }
  };

  // Obtiene la query string para los filtros del get de los cargos
  const getQueryString = () => {
    switch (type) {
      // Provinciales y dirección general
      case "gobiernoProvincial":
      case "gobiernoGeneral":
        return `?page=${page}&includeUser=true&isActive=${isActive}&findName=${search}&startDate=${startDate}&endDate=${endDate}&cargo=${filtroCargo}&tipoServicio=gobierno`;
      case "oficiosProvinciales":
      case "oficiosGenerales":
        return `?page=${page}&includeUser=true&isActive=${isActive}&findName=${search}&startDate=${startDate}&endDate=${endDate}&cargo=${filtroCargo}&tipoServicio=oficios`;
      case "otrosServiciosProvinciales":
      case "otrosServiciosGenerales":
        return `?page=${page}&includeUser=true&isActive=${isActive}&findName=${search}&startDate=${startDate}&endDate=${endDate}&cargo=${filtroCargo}&tipoServicio=otros`;
      // Representantes legales
      case "rlProvincial":
      case "rlGeneral":
      case "rlObra":
        return `?page=${page}&includeUser=true&isActive=${isActive}&findName=${search}&startDate=${startDate}&endDate=${endDate}`;
      // Comunitarios
      case "serviciosComunitarios":
        return `?page=${page}&includeUser=true&isActive=${isActive}&findName=${search}&startDate=${startDate}&endDate=${endDate}&cargo=${filtroCargo}`;
      // Equipos
      case "equiposComisiones":
        return `?page=${page}&includeUser=true&isActive=${isActive}&findName=${search}&startDate=${startDate}&endDate=${endDate}&cargo=${filtroCargo}`;
      // Misiones
      case "equiposDirectivosEducativo":
      case "equiposDirectivosAlojamiento":
      case "equiposDirectivosSalud":
      case "equiposDirectivosEspiritualidad":
      case "equiposDirectivosSocial":
        return `?page=${page}&includeUser=true&isActive=${isActive}&findName=${search}&startDate=${startDate}&endDate=${endDate}&cargo=${filtroCargo}`;
//112022 para poner hermanas que trabajana en la obra
      case "hermanasQueTrabajanObraOProyecto":
        return `?page=${page}&includeUser=true&isActive=${isActive}&findName=${search}&startDate=${startDate}&endDate=${endDate}&cargo=${filtroCargo}`;
      default:
        return "";
    }
  };

  // Obtiene el query string para el post y put
  const getQueryStringPostPut = () => {
    switch (type) {
      // Provincial y dirección general
      case "gobiernoProvincial":
      case "gobiernoGeneral":
        return `?tipoServicio=gobierno&isActive=true`;
      case "oficiosProvinciales":
      case "oficiosGenerales":
        return `?tipoServicio=oficios&isActive=true`;
      case "otrosServiciosProvinciales":
      case "otrosServiciosGenerales":
        return `?tipoServicio=otros&isActive=true`;
      default:
        return "?isActive=true";
    }
  };

  // Funcion que decide cuando se preasigna la fecha de endate en el formulario y cuando no tambien nos dice cuando cambiar la fecha de fin si cambia la fecha de inicio
  const handlerEndDate = () => {
    switch (type) {
      // Provinciales y dirección general
      case "gobiernoProvincial":
      case "oficiosProvinciales":
      case "oficiosGenerales":

        return 3;
      case "gobiernoGeneral":
        return 6;
      default:
        return false;
    }
  };

  // Función para comprobar que este cargo no esté ya elegido
  const cargoDisponible = async (miCargo, exclude = []) => {
    // Pedimos los cargos actuales para comprobarlos
    let cargosActuales = await getCargos(getUrl(), getQueryStringPostPut()).then((response) => {
      return response.items;
    });
    // Si el cargo es actual y no esta en el array de excludes
    return !cargosActuales.find((cargo) => cargo.cargo === miCargo && !exclude.includes(cargo.cargo));

  };

  // Nos indica si un cargo actual
  const esCargoActual = (miCargo) => {
    return new Date(miCargo.endDate) > new Date() || !miCargo.endDate;

  };

  // Indica cual es el orden entre dos cargos
  const compararCargos = (cargoA, cargoB) => {
    let arrayKeysCargosType = Object.keys(cargosContext[type]["cargos"]);
    let cargoPosA = arrayKeysCargosType.indexOf(cargoA.cargo);
    let cargoPosB = arrayKeysCargosType.indexOf(cargoB.cargo);
    if (cargoPosA < cargoPosB) return -1;
    if (cargoPosA > cargoPosB) return 1;
    return 0;
  };

  // Para manejar el cambio de fecha de los filtros
  const handleChangeStartDate = (e) => {
    setStartDate(e.target.value);
    setIsActive(false);
  };

  // Para manejar el cambio final de los filtros
  const handleChangeEndDate = (e) => {
    setEndDate(e.target.value);
    setIsActive(false);
  };

  // Para manejar el select de los cargos
  const handleChangeIsActive = (e) => {
    setStartDate("");
    setEndDate("");
    setIsActive(!isActive);
  };

  // Para manejar el filtro del cargo
  const handleChangeCargo = (e) => {
    setFiltroCargo(e.target.value);
  };

  // **************************************************** OBSERVADOR ************************************************
  const loadMore = async () => {
    if (!lastPageReached && !loading) {
      handleGetCargos(true);
    }
  };

  const target = useRef(null);

  useObserver(
    loadMore,
    {
      root: scrollingDiv.current,
      rootMargin: "0px",
      threshold: 1,
    },
    target,
    cargos
  );

  return (
    <div className="position-relative">
      <CustomSpinner animation={"border"} loading={loading} />
      {/* Filtros */}
      <CustomNavBar expand="md">
        {/* Cuando se hace pequeña la pantalla */}
        <Navbar.Toggle>
          <span className="align-text-bottom"> Filtros</span>
        </Navbar.Toggle>
        <Navbar.Collapse>
          <Form as="div" className="w-100">
            <Form.Row>
              <Form.Group as={Col} xs={12} md>
                <div className={"d-flex "}>
                  <FormControl
                    className="mr-1"
                    type="text"
                    onChange={(e) => {
                      setSearch(e.target.value);
                    }}
                    placeholder={"Búsqueda"}
                  />
                  <TooltipIcon content={"Búsqueda por nombre, apellidos o documento de identidad."} />
                </div>
              </Form.Group>
              {/* Si no estmaos en representantes legales */}
              {cargosContext[type]["cargos"] !== "rl" && (
                <Form.Group as={Col} xs={12} md>
                  <InputGroup className="mr-3">
                    <InputGroup.Prepend>
                      <InputGroup.Text>{cargosContext[type]["cargoServicio"]}</InputGroup.Text>
                    </InputGroup.Prepend>
                    <Form.Control as="select" onChange={handleChangeCargo} value={filtroCargo} custom>
                      <option value="">Todos</option>
                      {Object.keys(cargosContext[type]["cargos"]).length &&
                        Object.keys(cargosContext[type]["cargos"]).map((keyCargo) => {
                          return (
                            <option key={keyCargo} value={keyCargo}>
                              {cargosContext[type]["cargos"][keyCargo]}
                            </option>
                          );
                        })}
                    </Form.Control>
                  </InputGroup>
                </Form.Group>
              )}
            </Form.Row>
            <Form.Row>
              <Form.Group as={Col} xs={12} md>
                <InputGroup className="mr-3">
                  <InputGroup.Prepend>
                    <InputGroup.Text>{"Fecha inicio"}</InputGroup.Text>
                  </InputGroup.Prepend>
                  <Form.Control type="date" max={endDate} value={startDate} onChange={handleChangeStartDate} />
                </InputGroup>
              </Form.Group>
              <Form.Group as={Col} xs={12} md>
                <InputGroup className="mr-3">
                  <InputGroup.Prepend>
                    <InputGroup.Text>{"Fecha de fin"}</InputGroup.Text>
                  </InputGroup.Prepend>
                  <Form.Control type="date" min={startDate} value={endDate} onChange={handleChangeEndDate} />
                </InputGroup>
              </Form.Group>
              <Form.Group as={Col} xs={12} md>
                <InputGroup>
                  <Form.Group>
                    <Form.Check
                      type="checkbox"
                      label={cargosContext[type]["cargos"] !== "rl" ? `${cargosContext[type]["cargoServicio"]}s activos` : `Representantes legales activos`}
                      defaultChecked={isActive}
                      checked={isActive}
                      onClick={handleChangeIsActive}
                    />
                  </Form.Group>
                </InputGroup>
              </Form.Group>
            </Form.Row>
          </Form>
        </Navbar.Collapse>
      </CustomNavBar>
      <CustomTable ref={scrollingDiv}>
        <TablaCargos
          idEntidad={idEntidad}
          idSubEntidad={idSubEntidad}
          type={type}
          cargos={cargos}
          cargoDisponible={cargoDisponible}
          esCargoActual={esCargoActual}
          handlePutCargo={handlePutCargo}
          handleDeleteCargo={handleDeleteCargo}
        />
        <br ref={target} id="observable" />
      </CustomTable>
      <div className="d-flex justify-content-end">
        <Button
          variant="outline-primary"
          className={"mr-2"}
          size="sm"
          onClick={() => {
            modalSetShow(true, "80%");
            modalSetTitle(`Añadir ${cargosContext[type]["cargoServicio"].toLowerCase()}.`);
            modalSetContent(
              <FormCargo
                idEntidad={idEntidad}
                idSubEntidad={idSubEntidad}
                type={type}
                submissionHandler={handlePostCargo}
                defaultValues={{ startDate: dateToString2(new Date()), endDate: handlerEndDate() ? dateToString2(addYears(new Date(), handlerEndDate())) : "" }}
                cargoDisponible={cargoDisponible}
                handlerEndDate={handlerEndDate}
                noControl={false}
              />
            );
          }}
        >
          {`Añadir ${cargosContext[type]["cargoServicio"].toLowerCase()}`}
        </Button>
        <Button
          variant="outline-dark"
          size="sm"
          onClick={() => {
            modalSetShow(true, "80%");
            modalSetTitle(`Añadir ${cargosContext[type]["cargoServicio"].toLowerCase()} (sin restricciones).`);
            modalSetContent(
              <FormCargo
                idEntidad={idEntidad}
                idSubEntidad={idSubEntidad}
                type={type}
                submissionHandler={handlePostCargo}
                // Sino estamos en servicios comunitarios la fecha de inicio por defecto será tres años mas
                defaultValues={{ startDate: dateToString2(new Date()), endDate: handlerEndDate() ? dateToString2(addYears(new Date(), handlerEndDate())) : "" }}
                cargoDisponible={cargoDisponible}
                handlerEndDate={handlerEndDate}
                noControl={true}
              />
            );
          }}
        >
          {`Añadir ${cargosContext[type]["cargoServicio"].toLowerCase()} (sin restrincciones)`}
        </Button>
      </div>
    </div>
  );
};

export default Cargos;
